<template>
  <div
    v-if="isActive" ref="mmpModal" :class="wrapClass"
    :style="isWrapTransparent ? 'background-color: transparent;' : ''" class="popup_wrap">
    <div id="container" :class="containerClass">
      <!-- Full popup -->
      <template v-if="!fullWithHeader">
        <slot/>
      </template>

      <!-- Full popup with header -->
      <template v-else>
        <!-- header -->
        <div v-if="!hasHeaderSlot" id="header" class="popup_header">
          <div v-if="useDefaultHeader" class="popup_title">
            {{ title }}
          </div>
          <button type="button" class="btn_close" @click="$emit('close')"><span class="blind">팝업 닫기</span></button>
        </div>
        <div v-else id="header" class="popup_header">
          <slot name="header" />
        </div>
        <!-- //header -->

        <!-- content -->
        <div id="content" :class="contentClass">
          <slot name="content"/>
        </div>

        <div v-if="!hasFooterSlot" class="popup_footer">
          <div v-if="useDefaultFooter" class="btn_wrap">
            <a href="javascript:void(0)" class="btn_basic" @click="$emit('close')"><span class="btn_text">확인</span></a>
          </div>
        </div>
        <div v-else class="popup_footer">
          <slot name="footer" />
        </div>
        <!-- // content -->
      </template>
    </div>
  </div>
  <!-- //container -->
</template>

<script>
export default {
  name: 'MmpModal',
  props: {
    title: {
      type: String,
      default: null
    },
    fullModal: {
      type: Boolean,
      default: true
    },
    fullWithHeader: {
      type: Boolean,
      default: true
    },
    visible: {
      type: Boolean,
      required: true,
      default: false
    },
    mainclass: {
      type: [String, Object],
      default: ''
    },
    containerClass: {
      type: String,
      default: 'popup_inner'
    },
    useDefaultHeader: {
      type: Boolean,
      default: true
    },
    useDefaultFooter: {
      type: Boolean,
      default: true
    },
    contentClass: {
      type: String,
      default: 'popup_content'
    },
    position: {
      type: String,
      default: 'up',
      validator (value) {
        return [
          'up',
          'down',
          'right',
          'left'
        ].indexOf(value) > -1
      }
    },
    isWrapTransparent: {
      type: Boolean,
      default: false
    },
    scroll: {
      type: String,
      default: () => {
        return 'keep'
      },
      validator: (value) => {
        return [
          'clip',
          'keep'
        ].indexOf(value) >= 0
      }
    },
    // scroll lock 적용 여부
    scrollLock: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      savedScrollTop: null,
      isActive: this.visible || false
    }
  },
  computed: {
    wrapClass () {
      return {
        ...this.mainclass,
        'popup_full': this.fullModal
      }
    },
    hasHeaderSlot () {
      return this.$slots['header']
    },
    hasFooterSlot () {
      return this.$slots['footer']
    }
  },
  watch: {
    visible (value) {
      this.isActive = value
    },
    isActive () {
      this.handleScroll()
      this.handleIOSFocus()
    }
  },
  created () {
  },
  mounted () {
    if (this.isActive) this.handleScroll()
  },
  deactivated () {
    this.close()
  },
  beforeDestroy () {
    this.close()
    if (typeof window !== 'undefined') {
      // reset scroll
      document.documentElement.classList.remove('is-clipped')
      const savedScrollTop = !this.savedScrollTop
        ? document.documentElement.scrollTop
        : this.savedScrollTop
      document.body.classList.remove('overflow')
      document.documentElement.scrollTop = savedScrollTop
      document.body.style.top = null
    }
  },
  methods: {
    close () {
      /*
       * visible.sync 값으로 동기화 해주는 경우 화면 이동시 모달 팝업이 자동으로 해제(false) 처리됨
       * <mmp-modal
          :visible.sync="visible"/>
       */
      this.$emit('update:visible', false)
    },
    handleScroll (e) {
      if (typeof window === 'undefined') return

      if (e) {
        e.preventDefault()
        e.stopPropagation()
      }

      if (this.scroll === 'clip') {
        if (this.isActive) {
          document.documentElement.classList.add('is-clipped')
        } else {
          document.documentElement.classList.remove('is-clipped')
        }
        return
      }

      const el = document.scrollingElement || document.documentElement || document.body

      this.savedScrollTop = !this.savedScrollTop
        ? el.scrollTop
        : this.savedScrollTop

      if (this.isActive) {
        if (this.scrollLock) {
          setTimeout(() => {
            document.body.classList.add('overflow')
          })
        }
      } else {
        document.body.classList.remove('overflow')
      }

      if (this.isActive) {
        document.body.style.top = `-${this.savedScrollTop}px`
        return
      }

      el.scrollTop = this.savedScrollTop
      document.body.style.top = null
      this.savedScrollTop = null
    },
    handleIOSFocus () {
      if (!this.$utils.getUserAgent().iOS) {
        return
      }

      if (this.isActive) {
        // focus disable input/textarea
        if (typeof window !== 'undefined') {
          // dom element 내 input/textarea 비활성화
          const roots = document.querySelectorAll('input, textarea')
          for (const child of roots) {
            child.readOnly = true
            child.disabled = true
          }

          // 모달 팝업창 내 input/textarea만 활성화
          if (this.$refs.mmpModal) {
            const children = this.$refs.mmpModal.querySelectorAll('input, textarea')
            for (const child of children) {
              child.readOnly = false
              child.disabled = false
            }
          }
        }
      } else {
        // focus reset input/textarea
        const roots = document.querySelectorAll('input, textarea')
        for (const child of roots) {
          child.readOnly = false
          child.disabled = false
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/_common/mmp-popup/MmpModal.vue